import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Spin, Row, Col, Select, Input, Pagination, DatePicker } from 'antd';

import _ from 'lodash';
import cn from 'classnames';
import { browserHistory, Link } from 'react-router';
import Utils from 'utils/utils';
// import { formItemLayout } from 'constants/layout';

import { connect } from 'react-redux';
import { getScheduleList, getAllSchedules, deleteSchedule } from 'data/schedule';
import { getServiceFee } from 'data/config';
// import Utils from 'utils/utils';
import { TableHelper, exportAsExcel } from 'helpers/Table';
import { formatNumber } from 'utils/formatting';
import moment from 'moment';
// import classes from './ScheduleList.scss';
import classes from '../styles/ScheduleList.module.scss';

import COLUMNS from './ScheduleListColumns.js';

const pageLimit = 20;
const Confirm = Modal.confirm;
const { RangePicker } = DatePicker;

class ScheduleList extends Component {
  static propTypes = {
    // form: PropTypes.Any,
  };

  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
    this.changeSubcategory = this.changeSubcategory.bind(this);
    this.changeType = this.changeType.bind(this);
    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onUpdateCalendar = this.onUpdateCalendar.bind(this);
    this.renderCalendarFooter = this.renderCalendarFooter.bind(this);
    this.onTableChange = this.onTableChange.bind(this);

    this.onAddNewPageContent = this.onAddNewPageContent.bind(this);
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment();
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment().add(6, 'month');
    this.state = {
      collapseMobile: [],
      showModal: false,
      page: props.page,
      displaySearchValue: '',
      searchBy: '',
      selectedRowKeys: [],
      start,
      end,
      searchValue: props.location.query.q ? props.location.query.q : '',
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      selectedCategory: props.location.query.category ? props.location.query.category : 'all',
      selectedSubcategory: props.location.query.subcategory ? props.location.query.subcategory : 'all',
      selectedType: props.location.query.type ? props.location.query.type : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : 'start',

      loading: false,
      schedules: [],
      page: 1,
      classCount: 0,
      serviceFeeLevel: {},
    };
  }

  componentDidMount = async () => {
    const query = this.props.location.query;

    if (!query.start) {
      query.start = moment().format('DD-MM-YYYY');
      query.end = moment().add('6', 'month').format('DD-MM-YYYY');
    }
    if (!query.sortBy) {
      query.sortBy = 'start';
    }
    this.setState({
      loading: true,
    });
    const results = await getScheduleList(query);
    const feeResult = await getServiceFee();
    this.setState({
      loading: false,
      schedules: results.results,
      page: results.currentPage,
      classCount: results.count,
      serviceFeeLevel: feeResult,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillReceiveProps(props) {
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(3, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();
    this.setState({
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
      searchValue: props.location.query.q ? props.location.query.q : '',
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      selectedCategory: props.location.query.category ? props.location.query.category : 'all',
      selectedSubcategory: props.location.query.subcategory ? props.location.query.subcategory : 'all',
      selectedType: props.location.query.type ? props.location.query.type : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : 'start',
      start,
      end,
    });
  }
  componentWillUnmount() {
    if (this.backListener) {
      this.backListener();
    }
  }

  onAddNewPageContent() {
    this.setState({
      showModal: true,
      selectedRow: {
        pageName: this.state.selectedStatus,
      },
      isAddNew: true,
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
    // browserHistory.push(`/class/${record.slug}`);
  }

  onChangePage(page) {
    this.setState({
      page: page,
    });
    this.getScheduleList(_.merge(this.getCurrentQuery(), { page }));
    this.setState({
      page: page,
      selectedRowKeys: [],
    });
  }

  onSearch() {
    this.setState({
      page: 1,
      searchValue: this.state.displaySearchValue,
    });
    this.getScheduleList(_.merge(this.getCurrentQuery(), { q: this.state.displaySearchValue, page: 1 })).then((response) => {
      console.log(response);
    });
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onDateChange(date) {
    this.setState({
      start: date[0],
      end: date[1],
    });
  }

  onRowSelectChange(selectedRowKeys) {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }
  onUpdateCalendar(month) {
    this.setState({
      start: moment(),
      end: moment().add(month, 'month'),
    });
  }
  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }

  getCurrentQuery() {
    return {
      page: this.state.page,
      status: this.state.selectedStatus,
      q: this.state.searchValue,
      start: this.state.start.format('DD-MM-YYYY'),
      end: this.state.end.format('DD-MM-YYYY'),
      sortBy: this.state.sortBy,
    };
  }

  getScheduleList = async (query) => {
    if (!query.start) {
      query.start = moment().format('DD-MM-YYYY');
      query.end = moment().add('6', 'month').format('DD-MM-YYYY');
    }
    if (!query.sortBy) {
      query.sortBy = 'start';
    }
    this.setState({
      loading: true,
    });
    const results = await getScheduleList(query);
    const feeResult = await getServiceFee();
    this.setState({
      loading: false,
      schedules: results.results,
      page: results.currentPage,
      classCount: results.count,
      serviceFeeLevel: feeResult,

      selectedRowKeys: [],
    });

    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);

    return Promise.resolve();
  };

  changeCategory(category) {
    this.setState({
      selectedCategory: category,
      selectedSubcategory: 'all',
    });
  }

  changeSubcategory(subcategory) {
    this.setState({
      selectedSubcategory: subcategory,
    });
  }

  changeType(event) {
    console.log(event);
  }

  changeFocusPage(event) {
    const status = event.key;
    let start;
    let end;
    if (status === 'all' || status === 'upcoming') {
      start = moment();
      end = moment().add(6, 'month');
    } else {
      start = moment().subtract(1, 'year');
      end = moment();
    }
    this.setState(
      {
        selectedStatus: status,
        start,
        end,
        selectedRowKeys: [],
        page: 1,
      },
      () => {
        this.getScheduleList(_.merge(this.getCurrentQuery(), { status })).then((response) => {
          console.log(response);
        });
      },
    );
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: 'ยืนยันการลบตารางสอนที่เลือก',
      content: content || '',
      onOk: async () => {
        const ids = this.state.selectedRowKeys.map((key) => {
          return this.state.schedules[key]._id;
        });
        const promises = [];
        ids.forEach((id) => {
          promises.push(deleteSchedule(id));
        });

        await Promise.all(promises);

        this.getScheduleList(this.getCurrentQuery());
        this.setState({
          loading: false,
        });
        // this.onDelete(record)
      },
      onCancel: this.onCancel,
    });
  }

  exportToExcel = async () => {
    const resultObj = await getAllSchedules(this.getCurrentQuery());
    const results = resultObj.results;
    const content = results.map((singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const selectedStatusColumn = _.get(_.find(this.shceduleStatuses, { value: this.state.selectedStatus }), 'column');
    let columns = COLUMNS[selectedStatusColumn].map((colName) => {
      const col = _.find(this.columns, { columnName: colName });
      return col;
    });
    columns = _.compact(columns);
    exportAsExcel({
      filename: `SCHEDULES-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
      sheetName: 'Sheet1',
      columns,
      data: content,
    });
  };

  columns = [
    {
      ...TableHelper.defaultColumn('No.', 'code'),
      render: (value, record) => (
        <div className="">
          <Link to={`/class/${record.class._id}/schedule/${record._id}`}>{value} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
      sorter: true,
    },
    {
      ...TableHelper.dateColumn('Sche.\nDate', 'start'),
      render: (value, record) => {
        if (record.scheduleType === 'multiple') {
          const start = moment(record.start);
          const end = moment(record.end);
          return `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`;
        }
        return moment(record.start).format('DD/MM/YYYY');
      },
      renderExcel: (value, record) => {
        if (record.scheduleType === 'multiple') {
          const start = moment(record.start);
          const end = moment(record.end);
          return `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`;
        }
        return moment(record.start).format('DD/MM/YYYY');
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Class', 'class.name'),
      width: '250px',
      render: (value, record) => <Link to={`/class/${record.class._id}`}>{value}</Link>,
    },
    {
      ...TableHelper.dateColumn('Created', 'createdAt'),
      render: (value) => {
        return moment(value).format('DD/MM/YYYY');
      },
      renderExcel: (value) => {
        return moment(value).format('DD/MM/YYYY');
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Teacher', 'class.owner'),
      render: (value, record) => {
        const isVerified = _.get(record, 'owner.verified');
        return (
          <div>
            <Link to={`/teacher/${value._id}`}>{value.displayName}</Link> &nbsp;
            {isVerified && <Icon type="check-circle" className="text-primary" />}
          </div>
        );
      },
      renderExcel: (value) => value.displayName,
    },
    {
      ...TableHelper.defaultColumn('Regis.', 'classCapacity'),
      render: (value, record) => `${record.studentEnroll} / ${value}`,
      renderExcel: (value, record) => `${record.studentEnroll} / ${value}`,
    },
    {
      ...TableHelper.defaultColumn('Paid', 'paid'),
    },
    {
      ...TableHelper.defaultColumn('Status', 'status'),
      render: (value, record) => {
        if (record.isDeleted === true) {
          return 'Cancelled';
        } else if (record.isClosed === true) {
          return 'Closed';
        } else if (record.isSummary === true) {
          return 'Completed';
        }
        return 'Upcoming';
      },
    },
    {
      ...TableHelper.priceColumn('Ref.\nPrice', 'class.price'),
      render: (value) => formatNumber(value),
    },
    {
      ...TableHelper.priceColumn('Price', 'price'),
      render: (value) => formatNumber(value),
    },
    {
      ...TableHelper.priceColumn('EB\nDisc', 'discount'),
      render: (value) => `${formatNumber(value, '0')}%`,
    },
    {
      ...TableHelper.defaultColumn('SP\nDisc', 'multipleStudentPrices'),
      render: (value) => (value.length > 0 ? 'Yes' : 'No'),
      renderExcel: (value) => (value.length > 0 ? 'Yes' : 'No'),
    },
    {
      ...TableHelper.priceColumn('%Com\nFee', 'serviceFeePercentage'),
      render: (value, record) => {
        if (value) {
          return `${value.normal}%, ${value.repeat}%`;
        }
        const teacherLevel = _.get(record, 'class.owner.level');
        const feePercentage = this.state.serviceFeeLevel[teacherLevel];
        return `${feePercentage.normal}%, ${feePercentage.repeat}%[F]`;
      },
    },
    {
      ...TableHelper.priceColumn('%Com\nDisc', 'feeDiscount'),
      render: (value) => `${formatNumber(value, '0')}%`,
    },

    {
      columnName: '-',
      title: '',
      dataIndex: '',
      render: (value) => {
        return (
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Icon type="schedule" className={classes.commandIcon} />
          </div>
        );
      },
    },
  ];

  shceduleStatuses = [
    { label: 'All', value: 'all', column: 'all' },
    { label: 'Upcoming', value: 'upcoming', column: 'upcoming' },
    { label: 'Completed', value: 'completed', column: 'approved' },
    { label: 'Cancelled', value: 'cancelled', column: 'cancelled' },
    { label: 'Closed', value: 'closed', column: 'closed' },
  ];

  renderPageTopMenu() {
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.selectedStatus]} mode="horizontal" className={classes.menu}>
        {this.shceduleStatuses &&
          this.shceduleStatuses.map((singleClass) => (
            <Menu.Item key={singleClass.value} className={classes.dashRight}>
              <div>{singleClass.label} </div>
            </Menu.Item>
          ))}
      </Menu>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.schedules, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const selectedStatusColumn = _.get(_.find(this.shceduleStatuses, { value: this.state.selectedStatus }), 'column');
    let columns = COLUMNS[selectedStatusColumn].map((colName) => {
      const col = _.find(this.columns, { columnName: colName });
      return col;
    });
    columns = _.compact(columns);
    const hasRowSelection = this.state.selectedStatus === 'upcoming';
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
      },
      getCheckboxProps: (record) => {
        return {
          disabled: record.students.length > 0, // Column configuration not to be checked
        };
      },
      hideDefaultSelections: true,
    };
    // const rowSelection = {
    //   selectedRowKeys,
    //   onChange: this.onRowSelectChange,
    //   hideDefaultSelections: true,
    // };

    return (
      <div>
        <Table
          rowSelection={hasRowSelection ? rowSelection : undefined}
          columns={columns}
          dataSource={content}
          bordered
          pagination={false}
          onRowClick={this.onClickRow}
          onChange={this.onTableChange}
          scroll={{ x: 1400 }}
        />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.classCount} />
      </div>
    );
  }

  renderCalendarFooter() {
    return (
      <div className="text-center">
        <a onClick={() => this.onUpdateCalendar(1)}>1 Months</a> |&nbsp;
        <a onClick={() => this.onUpdateCalendar(3)}>3 Months</a> |&nbsp;
        <a onClick={() => this.onUpdateCalendar(6)}>6 Months</a> |
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
            {this.renderPageTopMenu()}
            <div className={classes.searchContainer}>
              <Row>
                <Col xs={7} className={classes.searchInputContainer}>
                  <Input prefix={<Icon type="search" />} placeholder="Search" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
                </Col>
                <Col xs={7}>
                  <RangePicker format="DD-MM-YYYY" renderExtraFooter={this.renderCalendarFooter} onChange={this.onDateChange} value={[this.state.start, this.state.end]} />
                </Col>

                <Button className="search-btn" onClick={this.onSearch}>
                  <Icon type="search" />
                </Button>
              </Row>
            </div>
            <div className="text-right">
              <a onClick={() => this.exportToExcel()} style={{ verticalAlign: -5 }}>
                <Icon type="file-excel" /> Export to excel
              </a>{' '}
              <div className="pull-right">
                {' '}
                {this.state.selectedRowKeys.length > 0 && this.state.selectedStatus === 'upcoming' && (
                  <Button type="danger" style={{ marginLeft: 15 }}>
                    <a onClick={() => this.showDeleteConfirm()}>Delete schedules ({this.state.selectedRowKeys.length})</a>
                  </Button>
                )}
              </div>
            </div>
            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}

export default connect((state) => (state) => ({}), {})(ScheduleList);
